import { FormProvider } from 'react-hook-form';
import { useEditClientContractTerm } from './hooks';
import { convertToPresentationProps } from './logics';
import { EditClientContractTermPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 編集 Container コンポーネント
 *
 * ## 構成
 * - 本体表示（読み取り項目・フォーム要素配置・Zod スキーマの骨格）: T03（PEN-980）で実装済み
 * - バリデーションルール詳細・API 送信処理: T04（PEN-981）で実装済み
 * - サーバー側は終了日に月末日以外を受け付けないため、convertToPresentationProps で
 *   終了日カレンダーの選択制限（月末日のみ選択可）を導出する（PEN-1158）。
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const EditClientContractTerm: React.FC<Props> = ({ clientId, termId }) => {
  const {
    state: { data, contractPlansData, methods, isSaving },
    actions: { handleSubmit, handleCancel },
  } = useEditClientContractTerm({ clientId, termId });

  const {
    clientOptions,
    contractPlanOptions,
    isStartedOnDisabled,
    isContractPlanDisabled,
    endedOnFromDate,
    endedOnDisabledDate,
  } = convertToPresentationProps({ data, contractPlansData });

  return (
    <FormProvider {...methods}>
      <EditClientContractTermPresentation
        clientOptions={clientOptions}
        contractPlanOptions={contractPlanOptions}
        isStartedOnDisabled={isStartedOnDisabled}
        isContractPlanDisabled={isContractPlanDisabled}
        endedOnFromDate={endedOnFromDate}
        endedOnDisabledDate={endedOnDisabledDate}
        isButtonDisabled={isSaving}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
